import { render, staticRenderFns } from "./teilnehmerTeaser.vue?vue&type=template&id=f57c9a50&scoped=true&"
import script from "./teilnehmerTeaser.vue?vue&type=script&lang=js&"
export * from "./teilnehmerTeaser.vue?vue&type=script&lang=js&"
import style0 from "./teilnehmerTeaser.vue?vue&type=style&index=0&id=f57c9a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57c9a50",
  null
  
)

export default component.exports